module.exports = __webpack_public_path__ + "static/img/u553.0816051.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bookCover/u553.jpg
// module id = yUGh
// module chunks = 1